import React, {useEffect, useState} from "react";
import Icon from "../../Icon";
import {Button} from "react-bootstrap";

const FileInput = ({ value, name, onChange, placeholder, inputProps, clearable = true, ...props }) => {

  const [file, setFile] = useState()
  const { logoFilenameInputProps } = inputProps

  useEffect(() => {
    if (file instanceof File || file instanceof Blob) {
      logoFilenameInputProps.onChange(file.name)
      const reader = new FileReader();
      reader.onload = function(e) {
        onChange(e.target.result)
      }
      reader.readAsDataURL(file);
    }
  }, [file])

  const clearFile = () => {
    setFile(null)
    onChange(null)
    logoFilenameInputProps.onChange(null)
  }

  return (<div style={{display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    alignItems: "center"
  }}>
    <div className="string form-control" style={{position: "relative",
      overflow: "hidden",
      flex: "1 1",
      padding: "0"}}>
      <div style={{background: "#eee",
        padding: "0 10px",
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle"}}>
        <div style={{display: "inline-block", verticalAlign: "middle"}}>Choose File</div>
      </div>
      <div style={{lineHeight: "100%",
        padding: "0 10px",
        display: "inline-block",
        color: `${value ? 'initial' : "hsl(0, 0%, 50%)"}`
      }}>{logoFilenameInputProps.value || placeholder || "No file chosen"}</div>
      <input
        style={{ opacity: 0, position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }}
        type="file"
        onChange={e => {
          setFile(e.target.files?.[0]);
        }}
      />
    </div>
    <Button onClick={clearFile} variant={"light"} style={{marginLeft: '5px'}}>
      <Icon icon={"trash"} style={{marginRight: 'initial'}}/>
    </Button>
  </div>)
}

export default FileInput;
